/* global analytics */

// import 'intersection-observer'
// import 'promise-polyfill/src/polyfill'
import { createComponent } from "@bigyouth/base";

// import lazySizes from 'lazysizes'
import "lazysizes/plugins/rias/ls.rias.min";
import "lazysizes/plugins/video-embed/ls.video-embed.min";
import "lazysizes/plugins/bgset/ls.bgset.min";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";

import "./polyfills";
import "./assets";

import "./style/styles.scss";

import "./components";
import * as features from "./features";

// Ghis stuff
import App from "./utils/starter-specific/App";

const app = new App("#app");
const trackingEnable = true;

Object.values(features).forEach(createComponent);

app.onReady(() => {
  console.log("the app is ready ... ok");

  // document.addEventListener('lazyriasmodifyoptions', function(event){
  //   let value = window.devicePixelRatio.toString()
  //   event.detail.dpr = (value > 4 ) ? '4.0' : Math.round(value).toFixed(1).toString()
  // });
  //
  // document.addEventListener('lazybeforesizes', function(event){
  //   let value = window.devicePixelRatio.toString()
  //   let dpr = (value > 4 ) ? 4 : Math.round(value)
  //   event.detail.width = event.detail.width / dpr
  // });
  /*
  Array.from(document.getElementsByClassName('btn-sign-up'), signInButton => {
    signInButton.addEventListener('click', e => {
      // see : https://segment.com/docs/guides/best-practices/what-are-best-practices-for-identifying-users/
      // Remember that alias must be called before identify

      // Our recommendation for when and how often you should call identify is as follows:
      // - After a user registers
      // - After a user logs in
      // - Upon loading any pages that are accessible by a logged in user

      let userId = document.getElementById('userid').value
      let email = document.getElementById('email').value
      let username = document.getElementById('username').value
      let firstname = document.getElementById('firstname').value
      let lastname = document.getElementById('lastname').value

      if (userId !== '') {
        console.log(`it's a sign up`)

        if (trackingEnable) {
          analytics.alias(userId)
          analytics.identify(userId, {
            email: email,
            username: username,
            firstname: firstname,
            lastname: lastname,
            name: firstname + ' ' + lastname,
            engagement: 50,
          })
          analytics.track('Signed up', {
            email: email,
          })
        } else {
          console.log(`it's a sign up, tracking disabled`)
          console.log(userId, username, firstname, lastname)
        }
      }
    })
  })

  Array.from(document.getElementsByClassName('btn-sign-in'), signInButton => {
    signInButton.addEventListener('click', e => {
      let userId = document.getElementById('sign-in-userid').value
      let email = document.getElementById('sign-in-email').value

      console.log(userId, email)

      if (userId !== '') {
        if (trackingEnable) {
          console.log(`it's a sign in`)
          analytics.identify(userId)
          analytics.track('Signed in', { email: email })
        } else {
          console.log(`it's a sign in, tracking disabled`)
          console.log(userId, email)
        }
      }
    })
  })
  */
});
